import { Component, OnInit, AfterViewInit, ViewChild, ɵConsole, ChangeDetectorRef, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { MediaObserver, MediaChange } from '@angular/flex-layout';

import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { MatStepper } from '@angular/material/stepper';

import { DeviceDetectorService } from 'ngx-device-detector';

import { PaymentConfirmationDialogComponent } from '../payment-confirmation-dialog/payment-confirmation-dialog.component';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';
import { UserService } from '../../services/user.service';
import { PaymentService } from '../../services/payment.service';

import { PaymentSelectType, PaymentSelected } from '../payment-note-list/payment-note-list.component';
import { PaymentDetail, PaymentConfirmationDialogData, OpenNotesPaymentInfoListItem, PaymentType, BankAccountType } from 'src/app/models/payment';

@Component({
    selector: 'app-payment-now',
    templateUrl: './payment-now.component.html',
    styleUrls: ['./payment-now.component.scss']
})
export class PaymentNowComponent implements OnInit {
    @ViewChild('paymentNowStepper', { static: false }) paymentNowStepper: MatStepper;

    private _handleError: HandleError;
    private _logging = environment.logging;
    private _display = environment.display;

    isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

    userFullName = '';
    participantIdString = '';
    participantId: number = null;

    showSpinner = false;

    step1Complete = false;
    step2Complete = false;
    step3Complete = false;
    step1Editable = true;
    step2Editable = true;
    step3Editable = true;

    paymentSelectType = PaymentSelectType;
    paymentSelected: PaymentSelected = {
        paymentSelectType: null,
        selectedId: null,
        selectedData: []
    };

    paymentAmountString: string = null;
    paymentAmountValue: number = null;

    constructor(
        private _route: ActivatedRoute,
        private _router: Router,
        private _errorHandler: ErrorHandler,
        private _userService: UserService,
        private _paymentService: PaymentService,
        private _deviceService: DeviceDetectorService,
        public paymentConfirmationDialog: MatDialog,
        public media: MediaObserver,
        private cdr: ChangeDetectorRef,
        private ngZone: NgZone
    ) {
        this._handleError = _errorHandler.createHandleError('PaymentNowComponent');
        this.userFullName = this._userService.getFullName();
        this.participantId = this._userService.getParticipantId();
        this.participantIdString = this.participantId.toString();

        const routeUrl = _route.snapshot.url.join('');

        if (routeUrl.toLowerCase().includes('payineligible') && this._userService.getNoteId() !== null) {
            this.handleIneligibleNotePayment(this.participantId, this._userService.getNoteId());
        }
        this.scrollToTop();
    }

    ngOnInit() { }

    handleIneligibleNotePayment(participantId: number, noteId: number): void {
        this.showSpinner = true;
        this._paymentService.getOpenNotesPaymentInfoList(participantId).subscribe(
            resultArray => {
                let paymentSelected: PaymentSelected;
                paymentSelected = {
                    paymentSelectType: PaymentSelectType.Note,
                    selectedId: noteId,
                    selectedData: this._getFilteredOpenNotesPaymentInfoListItems(noteId, resultArray)
                };

                if (this._logging.serviceCallTraceLog) {
                    console.log('PaymentNowComponent.handleIneligibleNotePayment :: result.length = ' + resultArray.length);
                }
                if (this._logging.serviceDataTraceLog) {
                    console.log('PaymentNowComponent.handleIneligibleNotePayment :: result = ' + JSON.stringify(resultArray));
                }
                this.showSpinner = false;
                this._userService.clearNoteId();
                this.step1Editable = false;
                this.onPaymentNoteListSelected(paymentSelected);
            },
            error => this._handleError('handleIneligibleNotePayment', error)
        );
    }

    onPaymentNoteListSelected(paymentSelected: PaymentSelected) {
        if (this._userService.isLoggedIn()) {
            if (
                paymentSelected !== undefined &&
                paymentSelected !== null &&
                paymentSelected.selectedId !== null &&
                paymentSelected.selectedId.toString().length > 0
            ) {
                this.paymentSelected = paymentSelected;
                this.step1Complete = true;
                setTimeout(() => {
                    this.paymentNowStepper.next();

                    const stepId = this.paymentNowStepper._getStepLabelId(this.paymentNowStepper.selectedIndex);
                    const stepElement = document.getElementById(stepId);
                    if (stepElement) {
                        setTimeout(() => {
                            stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
                        }, 250);
                    }
                });
            } else {
                this.paymentSelected = {
                    paymentSelectType: null,
                    selectedId: null,
                    selectedData: []
                };
                this.step1Complete = false;
            }
        }
    }

    public onPaymentAmountDataComplete(event: any) {
        if (this.paymentNowStepper !== undefined && this.paymentNowStepper !== null) {
            // const stepId = this.paymentNowStepper._getStepLabelId(this.paymentNowStepper.selectedIndex);
            const stepId = this.paymentNowStepper._getStepLabelId(0);
            const stepElement = document.getElementById(stepId);
            if (stepElement) {
                setTimeout(() => {
                    stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
                }, 250);
            }
        }
    }

    onPaymentAmountSelected(paymentAmount: number) {
        if (this._userService.isLoggedIn()) {
            if (paymentAmount !== undefined && paymentAmount !== null && paymentAmount > 0) {
                this.paymentAmountString = paymentAmount.toFixed(2);
                this.paymentAmountValue = paymentAmount;
                this.step2Complete = true;
                setTimeout(() => {
                    this.paymentNowStepper.next();
                });
            } else {
                this.paymentAmountString = null;
                this.paymentAmountValue = null;
                this.step2Complete = false;
            }
        }
    }

    public onPaymentFormDataComplete(event: any) {
        // const stepId = this.paymentNowStepper._getStepLabelId(this.paymentNowStepper.selectedIndex);
        const stepId = this.paymentNowStepper._getStepLabelId(1);
        const stepElement = document.getElementById(stepId);
        if (stepElement) {
            setTimeout(() => {
                stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
            }, 250);
        }
    }

    onPaymentSubmitted(paymentDetail: PaymentDetail) {
        if (this._userService.isLoggedIn()) {
            this.cdr.markForCheck();
            this.cdr.detectChanges();
            this.ngZone.run(() => {
                setTimeout(() => {
                    this.openPaymentConfirmationDialog(paymentDetail);
                }, 0);
            });
        }
    }

    onPaymentCanceled(): void {
        if (this._userService.isLoggedIn()) {
            this.step1Complete = false;
            this.step2Complete = false;
            this.step3Complete = false;
            this.paymentNowStepper.reset();
        }
    }

    cancelPaymentNow(): void {
        if (this._userService.isLoggedIn()) {
            this.step1Complete = false;
            this.step2Complete = false;
            this.step3Complete = false;
            this.paymentNowStepper.reset();

            if (this._logging.navigationTraceLog) {
                console.log('PaymentNowComponent.cancelPaymentNow');
            }
            this._router.navigate(['']);
        }
    }

    openPaymentConfirmationDialog(paymentDetail: PaymentDetail): void {
        const paymentConfirmationDialogData: PaymentConfirmationDialogData = this._paymentService.getNewPaymentConfirmationDialogData();
        paymentConfirmationDialogData.dialogTitle = 'Pay Now';
        paymentConfirmationDialogData.paymentDetail = paymentDetail;

        if (this._logging.navigationTraceLog) {
            console.log('PaymentNowComponent.openPaymentConfirmationDialog :: Dialog Opened');
        }

        // May need to use screen height as the width if the device browser does not flip the screen width & height on orientation changes
        // const useScreenHeightAsWidth: boolean = window.innerWidth > window.innerHeight && screen.width < screen.height;
        // const screenWidth: number = useScreenHeightAsWidth ? screen.height : this._deviceService.isDesktop() ? window.innerWidth : screen.width;

        // let matDialogConfig: MatDialogConfig;
        // if (screenWidth < this._display.dialogDisplayDialogTriggerWidth) {
        //     matDialogConfig = {
        //         width: '95%',
        //         height: '75%',
        //         disableClose: true,
        //         data: paymentConfirmationDialogData
        //     };
        // } else {
        //     matDialogConfig = {
        //         width: '40%',
        //         disableClose: true,
        //         data: paymentConfirmationDialogData
        //     };
        // }

        // May need to use screen height as the width if the device browser does not flip the screen width & height on orientation changes
        const useScreenHeightAsWidth: boolean = window.innerWidth > window.innerHeight && screen.width < screen.height;
        const screenWidth: number = useScreenHeightAsWidth
            ? screen.height
            : this._deviceService.isDesktop()
                ? window.innerWidth
                : screen.width;

        let matDialogConfig: MatDialogConfig;
        if (screenWidth < this._display.dialogDisplayDialogTriggerWidth) {
            matDialogConfig = {
                width: '95%',
                height: '95%',
                disableClose: true,
                maxWidth: '100vw',
                maxHeight: '100vh',
                data: paymentConfirmationDialogData
            };
        } else {
            matDialogConfig = {
                width: '95%',
                disableClose: true,
                data: paymentConfirmationDialogData
            };
        }

        const dialogRef = this.paymentConfirmationDialog.open(PaymentConfirmationDialogComponent, matDialogConfig);

        dialogRef.afterClosed().subscribe(returnData => {
            if (this._logging.navigationTraceLog) {
                console.log('PaymentNowComponent.openPaymentConfirmationDialog :: Dialog Closed');
            }

            const paymentConfirmationDialogDataResponse: PaymentConfirmationDialogData = returnData;
            if (
                paymentConfirmationDialogDataResponse !== undefined &&
                paymentConfirmationDialogDataResponse !== null &&
                paymentConfirmationDialogDataResponse.paymentOk !== undefined &&
                paymentConfirmationDialogDataResponse.paymentOk !== null &&
                paymentConfirmationDialogDataResponse.paymentOk === true
            ) {
                this.step3Complete = true;
                if (this._logging.navigationTraceLog) {
                    console.log('PaymentNowComponent.openPaymentConfirmationDialog');
                }
                this._router.navigate(['']);
            } else {
                this.step3Complete = false;
            }
        });
    }

    openPaymentConfirmationDialogMock(): void {
        // Example mock object for PaymentDetail

        const mockPaymentDetail: PaymentDetail = {
            participantId: 12345,
            noteIds: "1001,1002",
            name: "John Doe",
            addressLine1: "123 Main St",
            addressLine2: "Apt 4B",
            city: "Springfield",
            state: "IL",
            zipCode: "62704",
            paymentAmount: 250.00,
            paymentDueDay: 15,
            loanProgram: "Standard Loan",
            servicingCompany: "Acme Servicing",
            paymentType: PaymentType.ApplePay,
            bankRoutingNumber: "021000021",
            bankAccountNumber: "123456789",
            bankAccountConfirmNumber: "123456789",
            bankAccountType: BankAccountType.Checking,
            userName: "johndoe",
            paymentRef: "REF123456",
            checkPaymentId: "CHK987654",
            confirmationCode: "CONF20240523",
            responseCode: "00",
            responseMessage: "Approved",
            nonce: "fake-valid-nonce",
            deviceData: "device-data-mock",
            partiFirstName: "John",
            partiLastName: "Doe",
            partiEmail: "john.doe@example.com",
            creditCardBin: "411111",
            creditCardType: "Visa",
            lastFourCreditCard: "1111",
            creditCardExpMonth: "12",
            creditCardExpYear: "2027",
            brainTreePaymentType: "credit_card",
            brainTreeLenderProgramCode: "LPCODE123"
        };

        const paymentConfirmationDialogData: PaymentConfirmationDialogData = this._paymentService.getNewPaymentConfirmationDialogData();
        paymentConfirmationDialogData.dialogTitle = 'Pay Now';
        paymentConfirmationDialogData.paymentDetail = mockPaymentDetail;

        if (this._logging.navigationTraceLog) {
            console.log('PaymentNowComponent.openPaymentConfirmationDialog :: Dialog Opened');
        }

        // May need to use screen height as the width if the device browser does not flip the screen width & height on orientation changes
        const useScreenHeightAsWidth: boolean = window.innerWidth > window.innerHeight && screen.width < screen.height;
        const screenWidth: number = useScreenHeightAsWidth ? screen.height : this._deviceService.isDesktop() ? window.innerWidth : screen.width;

        // let matDialogConfig: MatDialogConfig;
        // if (screenWidth < this._display.dialogDisplayDialogTriggerWidth) {
        //     matDialogConfig = {
        //         width: '95%',
        //         height: '75%',
        //         disableClose: true,
        //         data: paymentConfirmationDialogData
        //     };
        // } else {
        //     matDialogConfig = {
        //         width: '40%',
        //         disableClose: true,
        //         data: paymentConfirmationDialogData
        //     };
        // }

        const matDialogConfig: MatDialogConfig = {
            width: '95%',
            height: '95%',
            disableClose: true,
            maxWidth: '100vw',
            maxHeight: '100vh',
            data: paymentConfirmationDialogData
        };

        const dialogRef = this.paymentConfirmationDialog.open(PaymentConfirmationDialogComponent, matDialogConfig);

        dialogRef.afterClosed().subscribe(returnData => {
            if (this._logging.navigationTraceLog) {
                console.log('PaymentNowComponent.openPaymentConfirmationDialog :: Dialog Closed');
            }

            const paymentConfirmationDialogDataResponse: PaymentConfirmationDialogData = returnData;
            if (
                paymentConfirmationDialogDataResponse !== undefined &&
                paymentConfirmationDialogDataResponse !== null &&
                paymentConfirmationDialogDataResponse.paymentOk !== undefined &&
                paymentConfirmationDialogDataResponse.paymentOk !== null &&
                paymentConfirmationDialogDataResponse.paymentOk === true
            ) {
                this.step3Complete = true;
                if (this._logging.navigationTraceLog) {
                    console.log('PaymentNowComponent.openPaymentConfirmationDialog');
                }
                this._router.navigate(['']);
            } else {
                this.step3Complete = false;
            }
        });
    }
    scrollToTop() {
        const contentStart = document.getElementsByClassName('mat-sidenav-content');
        if (contentStart.length > 0) {
            contentStart[0].scrollTop = 0;
        }
    }

    private _getFilteredOpenNotesPaymentInfoListItems(
        selectedNoteId: number,
        openNotesPaymentInfoList: OpenNotesPaymentInfoListItem[]
    ): OpenNotesPaymentInfoListItem[] {
        let selectedData: OpenNotesPaymentInfoListItem[] = [];
        selectedData = openNotesPaymentInfoList.filter(x => x.noteId === selectedNoteId);
        return selectedData;
    }
}
